module.exports = __webpack_public_path__ + "img/unlock.4a2efe12.svg";